/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  GetFursCertificate200,
  UploadFursCertificate200,
  UploadFursCertificateBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Upload a P12/PFX certificate for FURS fiscalization. The certificate will be processed to extract expiry date and stored securely. The passphrase will be encrypted before storage. Certificate is entity-specific and required for fiscalizing invoices.
 * @summary Upload FURS certificate
 */
export type uploadFursCertificateResponse200 = {
  data: UploadFursCertificate200
  status: 200
}

export type uploadFursCertificateResponse400 = {
  data: Error
  status: 400
}

export type uploadFursCertificateResponse401 = {
  data: Error
  status: 401
}

export type uploadFursCertificateResponse403 = {
  data: Error
  status: 403
}

export type uploadFursCertificateResponse404 = {
  data: Error
  status: 404
}

export type uploadFursCertificateResponse422 = {
  data: ValidationError
  status: 422
}

export type uploadFursCertificateResponse500 = {
  data: Error
  status: 500
}

export type uploadFursCertificateResponseSuccess = (uploadFursCertificateResponse200) & {
  headers: Headers;
};
export type uploadFursCertificateResponseError = (uploadFursCertificateResponse400 | uploadFursCertificateResponse401 | uploadFursCertificateResponse403 | uploadFursCertificateResponse404 | uploadFursCertificateResponse422 | uploadFursCertificateResponse500) & {
  headers: Headers;
};

export type uploadFursCertificateResponse = (uploadFursCertificateResponseSuccess | uploadFursCertificateResponseError)

export const getUploadFursCertificateUrl = () => {


  

  return `/fiscalization/furs/settings/certificate`
}

export const uploadFursCertificate = async (uploadFursCertificateBody: UploadFursCertificateBody, options?: RequestInit): Promise<uploadFursCertificateResponse> => {
    const formData = new FormData();
if(uploadFursCertificateBody.file !== undefined) {
 formData.append(`file`, uploadFursCertificateBody.file);
 }
if(uploadFursCertificateBody.passphrase !== undefined) {
 formData.append(`passphrase`, uploadFursCertificateBody.passphrase);
 }

  return customFetch<uploadFursCertificateResponse>(getUploadFursCertificateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  

/**
 * Retrieve certificate metadata including expiry date and upload time. Does not return the certificate or private key.
 * @summary Get certificate metadata
 */
export type getFursCertificateResponse200 = {
  data: GetFursCertificate200
  status: 200
}

export type getFursCertificateResponse400 = {
  data: Error
  status: 400
}

export type getFursCertificateResponse401 = {
  data: Error
  status: 401
}

export type getFursCertificateResponse403 = {
  data: Error
  status: 403
}

export type getFursCertificateResponse404 = {
  data: Error
  status: 404
}

export type getFursCertificateResponse500 = {
  data: Error
  status: 500
}

export type getFursCertificateResponseSuccess = (getFursCertificateResponse200) & {
  headers: Headers;
};
export type getFursCertificateResponseError = (getFursCertificateResponse400 | getFursCertificateResponse401 | getFursCertificateResponse403 | getFursCertificateResponse404 | getFursCertificateResponse500) & {
  headers: Headers;
};

export type getFursCertificateResponse = (getFursCertificateResponseSuccess | getFursCertificateResponseError)

export const getGetFursCertificateUrl = () => {


  

  return `/fiscalization/furs/settings/certificate`
}

export const getFursCertificate = async ( options?: RequestInit): Promise<getFursCertificateResponse> => {
  
  return customFetch<getFursCertificateResponse>(getGetFursCertificateUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Delete the FURS certificate for the entity. This will remove both the uploaded file reference and the extracted certificate from the database.
 * @summary Delete FURS certificate
 */
export type deleteFursCertificateResponse204 = {
  data: void
  status: 204
}

export type deleteFursCertificateResponse400 = {
  data: Error
  status: 400
}

export type deleteFursCertificateResponse401 = {
  data: Error
  status: 401
}

export type deleteFursCertificateResponse403 = {
  data: Error
  status: 403
}

export type deleteFursCertificateResponse404 = {
  data: Error
  status: 404
}

export type deleteFursCertificateResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteFursCertificateResponse500 = {
  data: Error
  status: 500
}

export type deleteFursCertificateResponseSuccess = (deleteFursCertificateResponse204) & {
  headers: Headers;
};
export type deleteFursCertificateResponseError = (deleteFursCertificateResponse400 | deleteFursCertificateResponse401 | deleteFursCertificateResponse403 | deleteFursCertificateResponse404 | deleteFursCertificateResponse422 | deleteFursCertificateResponse500) & {
  headers: Headers;
};

export type deleteFursCertificateResponse = (deleteFursCertificateResponseSuccess | deleteFursCertificateResponseError)

export const getDeleteFursCertificateUrl = () => {


  

  return `/fiscalization/furs/settings/certificate`
}

export const deleteFursCertificate = async ( options?: RequestInit): Promise<deleteFursCertificateResponse> => {
  
  return customFetch<deleteFursCertificateResponse>(getDeleteFursCertificateUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

